"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBreakpoints = exports.getMediaQueries = exports.getOrientation = exports.getMediaType = exports.getBreakpointsWithEquality = exports.getGreaterThan = exports.getIs = exports.getLessThan = void 0;
var lodash_1 = require("lodash");
var css_mediaquery_1 = __importDefault(require("css-mediaquery"));
var constants_1 = require("./constants");
function getLessThan(currentMediaType, breakpoints) {
    var currentOrder = breakpoints[currentMediaType];
    return lodash_1.mapValues(breakpoints, function (breakpoint) { return currentOrder < breakpoint; });
}
exports.getLessThan = getLessThan;
function getIs(currentMediaType, breakpoints) {
    return lodash_1.mapValues(breakpoints, function (breakpoint, mediaType) { return mediaType === currentMediaType; });
}
exports.getIs = getIs;
function getGreaterThan(currentMediaType, breakpoints) {
    // get the ordering of the current media type
    var currentOrder = breakpoints[currentMediaType];
    return lodash_1.mapValues(breakpoints, function (breakpoint) { return currentOrder > breakpoint; });
}
exports.getGreaterThan = getGreaterThan;
function getBreakpointsWithEquality(currentMediaType, breakpoints) {
    return lodash_1.mapValues(breakpoints, function (value, mediaType) {
        return value || currentMediaType === mediaType;
    });
}
exports.getBreakpointsWithEquality = getBreakpointsWithEquality;
function getMediaType(width, mediaQueries) {
    return (lodash_1.keys(mediaQueries).find(function (breakpoint) {
        var _a = mediaQueries[breakpoint], min = _a[0], max = _a[1];
        return width >= min && width <= max;
    }) || constants_1.infinityName);
}
exports.getMediaType = getMediaType;
function getOrientation(deviceMock) {
    if (deviceMock === void 0) { deviceMock = {}; }
    // Fallback function is used when there is no window available
    // When it is used, we don't have a device to test mq
    // Device is passed as a second arg,
    var matchMediaFn = function (query) {
        return typeof (window === null || window === void 0 ? void 0 : window.matchMedia) === 'function'
            ? window.matchMedia(query).matches
            : css_mediaquery_1.default.match(query, deviceMock);
    };
    var mediaQueries = {
        portrait: '(orientation: portrait)',
        landscape: '(orientation: landscape)',
    };
    // there is a window, so compute the true orientation
    return lodash_1.reduce(mediaQueries, function (result, key, query) {
        // return the new type if the query matches otherwise the previous one
        return matchMediaFn(mediaQueries[query]) ? query : result;
        // use the default orientation
    }, constants_1.defaultOrientation);
}
exports.getOrientation = getOrientation;
function getMediaQueries(breakpoints) {
    var sortedBreakpoints = lodash_1.sortBy(lodash_1.toPairs(breakpoints), function (_a) {
        var value = _a[1];
        return value;
    });
    return sortedBreakpoints.reduce(function (acc, _a, idx, arr) {
        var key = _a[0], value = _a[1];
        var prev = arr[idx - 1];
        var prevValue = prev ? prev[1] : -1;
        acc[key] = [prevValue + 1, value];
        return acc;
    }, {});
}
exports.getMediaQueries = getMediaQueries;
function getBreakpoints(store) {
    var storeState = store.getState();
    return storeState.viewport.breakpoints;
}
exports.getBreakpoints = getBreakpoints;
//# sourceMappingURL=utils.js.map